module.exports = __webpack_public_path__ + "static/media/dashboard_dark.760e9e16.svg";